import { GridSelectionModel } from '@common-components';
import { MarketingReportMarketRequest } from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/MarketingReport/utils';
import getColumns from './columnsConfig';
import StyledDataGrid from './StyledDataGrid';

export interface MarketingReportContentProps {
  marketRequests: MarketingReportMarketRequest[];
  setSelectionModel: (newSelection: GridSelectionModel) => void;
  selectionModel: GridSelectionModel;
  showLoader: () => void;
  hideLoader: () => void;
  setMarketIdInEditMode: (id: string) => void;
  marketIdInEditMode: string;
  isInformationRequestsReport: boolean;
}

function MarketingDataGrid({
  marketRequests,
  selectionModel,
  setSelectionModel,
  showLoader,
  hideLoader,
  setMarketIdInEditMode,
  marketIdInEditMode,
  isInformationRequestsReport,
}: MarketingReportContentProps) {
  return (
    <StyledDataGrid
      disableVirtualization
      hideFooter
      rows={marketRequests}
      columns={getColumns(
        showLoader,
        hideLoader,
        setMarketIdInEditMode,
        marketIdInEditMode,
        isInformationRequestsReport,
      )}
      hideFooterPagination
      onSelectionModelChange={setSelectionModel}
      selectionModel={selectionModel}
      disableSelectionOnClick
      checkboxSelection
      disableColumnMenu
    />
  );
}

export default MarketingDataGrid;
